module.exports = __webpack_public_path__ + "static/s-925b574df51c554a034c694e5e54d8a4.mp4";